module.exports = __webpack_public_path__ + "static/media/grad10.86bbcbcd.jpg";